import AvailableActions from '@/types/available-actions';
import { userHasPermission } from './permissions';
import User from '@/types/user';

export enum ENTITY_CLASS {
  PORTFOLIOS = 'portfolios',
  COMPARISONS = 'comparisons',
}

export const initAvailableActionsToTrue = () => ({
  read: true,
  clone: true,
  edit: true,
  delete: true,
});

export const initAvailableActionsToFalse = () => ({
  read: false,
  clone: false,
  edit: false,
  delete: false,
});

export const initAvailableActionsToRead = () => ({
  read: true,
  clone: false,
  edit: false,
  delete: false,
});

export const initAvailableActionsToCopy = () => ({
  read: true,
  clone: true,
  edit: false,
  delete: false,
});

export const applyPermissionsToAvailableActions = (entity: AvailableActions, entityClass: ENTITY_CLASS, user: User): any => {
  const wildcard = `${entityClass}All`;
  const allTrue = userHasPermission(user, wildcard);
  let { availableActions } = entity;

  if (availableActions == null) {
    availableActions = initAvailableActionsToTrue();
  }

  availableActions.read = availableActions.read && (allTrue || userHasPermission(user, `${entityClass}Read`));
  availableActions.clone = availableActions.clone && (allTrue || userHasPermission(user, `${entityClass}Clone`));
  availableActions.edit = availableActions.edit && (allTrue || userHasPermission(user, `${entityClass}Edit`));
  availableActions.delete = availableActions.delete && (allTrue || userHasPermission(user, `${entityClass}Delete`));

  return {
    ...entity,
    availableActions,
  };
};
